import { render } from "./DepartmentNode.vue?vue&type=template&id=5ead167c&scoped=true"
import script from "./DepartmentNode.vue?vue&type=script&lang=js"
export * from "./DepartmentNode.vue?vue&type=script&lang=js"

import "./DepartmentNode.vue?vue&type=style&index=0&id=5ead167c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ead167c"]])

export default __exports__